<template>
  <div class="row">
    <div class="col-12 col-lg-3 text--primary">{{ label }}</div>
    <div class="col-4 col-lg-3 text--primary text--bold">
      <div class="row d-lg-none text--small text--secondary">
        Last 3
      </div> 
      {{ recentData }}
    </div>
    <div class="col-4 col-lg-3 text--primary text--bold">
      <div class="row d-lg-none text--small text--secondary">
        Season
      </div> 
      {{ seasonData }}
    </div>
    <div class="col-4 col-lg-3 text--primary text--bold">
      <div class="row d-lg-none text--small text--secondary">
        All Time
      </div> 
      {{ allTimeData }}
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    label: { type: String, required: true },
    recentData: { type: String, required: true },
    seasonData: { type: String, required: true },
    allTimeData: { type: String, required: true },
  },
};
</script>